export const defaultMapPinColor = '#fe0300'
